import React, { useState } from "react"
import Modal from "react-modal"
import { faTrash } from "@fortawesome/free-solid-svg-icons"
import PropTypes from "prop-types"
import Button from "./Button"
import IconButton from "./IconButton"
import Dialog from "./Dialog"

Modal.setAppElement("#root")

const DeleteConfirmationDialog = ({ text = "", item, onDelete, iconOnly }) => {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const handleDelete = () => {
    onDelete(item)
    closeModal()
  }

  return (
    <>
      {iconOnly ? (
        <IconButton onClick={openModal} delete icon={faTrash} />
      ) : (
        <Button onClick={openModal} delete icon={faTrash}>
          {text}
        </Button>
      )}

      <Dialog
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Delete Confirmation"
      >
        <h2>Delete Confirmation</h2>
        <p>Are you sure you want to delete {item.name}?</p>
        <Button onClick={handleDelete}>Yes</Button>
        <Button onClick={closeModal}>No</Button>
      </Dialog>
    </>
  )
}

DeleteConfirmationDialog.propTypes = {
  item: PropTypes.object,
  onDelete: PropTypes.func,
  text: PropTypes.string,
  iconOnly: PropTypes.bool,
}

export default DeleteConfirmationDialog
